import NumericComponent from "./NumericComponent";

export default NumericComponent;
